/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CategoryWithResults } from './CategoryWithResults';
import {
    CategoryWithResultsFromJSON,
    CategoryWithResultsFromJSONTyped,
    CategoryWithResultsToJSON,
    CategoryWithResultsToJSONTyped,
} from './CategoryWithResults';

/**
 * 
 * @export
 * @interface TournamentResultsResponse
 */
export interface TournamentResultsResponse {
    /**
     * 
     * @type {string}
     * @memberof TournamentResultsResponse
     */
    tournamentId?: string;
    /**
     * 
     * @type {Array<CategoryWithResults>}
     * @memberof TournamentResultsResponse
     */
    categories?: Array<CategoryWithResults>;
}

/**
 * Check if a given object implements the TournamentResultsResponse interface.
 */
export function instanceOfTournamentResultsResponse(value: object): value is TournamentResultsResponse {
    return true;
}

export function TournamentResultsResponseFromJSON(json: any): TournamentResultsResponse {
    return TournamentResultsResponseFromJSONTyped(json, false);
}

export function TournamentResultsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentResultsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tournamentId': json['tournamentId'] == null ? undefined : json['tournamentId'],
        'categories': json['categories'] == null ? undefined : ((json['categories'] as Array<any>).map(CategoryWithResultsFromJSON)),
    };
}

export function TournamentResultsResponseToJSON(json: any): TournamentResultsResponse {
    return TournamentResultsResponseToJSONTyped(json, false);
}

export function TournamentResultsResponseToJSONTyped(value?: TournamentResultsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tournamentId': value['tournamentId'],
        'categories': value['categories'] == null ? undefined : ((value['categories'] as Array<any>).map(CategoryWithResultsToJSON)),
    };
}

